import {CommonModule} from '@angular/common';
import {Component, inject} from '@angular/core';
import {FetchProductsStore} from '@em/data-feed/data-access-products';
import {EmIconModule} from '@em/shared/ui';
import {formatRelative} from '@em/shared/util-date-time';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-fetch-products-info-text',
  imports: [CommonModule, TranslateModule, EmIconModule],
  templateUrl: './fetch-products-info-text.component.html',
  styleUrls: ['./fetch-products-info-text.component.scss'],
})
export class EmFetchProductsInfoTextComponent {
  private readonly _fetchProductsStore = inject(FetchProductsStore);

  protected readonly formatRelative = formatRelative;
  protected lastSuccess$ = this._fetchProductsStore.lastSuccess$;
  protected lastFail$ = this._fetchProductsStore.lastFail$;
  protected neverFetched$ = this._fetchProductsStore.neverFetched$;
}
